import type { ReactNode } from 'react';
import { Col, Row } from 'ui';
import { ChatPageLayout } from '../chat-page-layout';

type P = {
  left: ReactNode;
  right: ReactNode;
};

const ChatContentLayout = ({ left, right }: P) => (
  <ChatPageLayout>
    <Row className="chat-content-layout" wrap={false}>
      <Col className="chat-content-layout__sidebar">{left}</Col>
      <Col className="chat-content-layout__content" flex="auto">
        {right}
      </Col>
    </Row>
  </ChatPageLayout>
);

export default ChatContentLayout;
